import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { services } from '@/mocks/data';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <div className="w-8 h-8 md:w-9 md:h-9 rounded-lg bg-primary-500 flex items-center justify-center">
              <span className="text-background-50 font-bold text-sm md:text-base">91</span>
            </div>
            <span className={`font-heading text-lg md:text-xl font-bold ${
              scrolled || !isHome ? 'text-foreground-900' : 'text-white'
            }`}>
              91.cn
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {services.map((s) => (
              <Link
                key={s.slug}
                to={`/category/${s.slug}`}
                className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors hover:text-primary-500 ${
                  scrolled || !isHome ? 'text-foreground-700' : 'text-white/90'
                }`}
              >
                {s.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors hover:text-primary-500 ${
                scrolled || !isHome ? 'text-foreground-700' : 'text-white/90'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="tel:400-810-9191"
              className={`text-sm flex items-center gap-1.5 whitespace-nowrap cursor-pointer ${
                scrolled || !isHome ? 'text-foreground-600' : 'text-white/80'
              }`}
            >
              <i className="ri-phone-line"></i>
              400-810-9191
            </a>
            <Link
              to="/category/domain-registration"
              className="bg-primary-500 hover:bg-primary-600 text-background-50 px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer transition-colors"
            >
              立即开始
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-md cursor-pointer ${
              scrolled || !isHome ? 'text-foreground-900' : 'text-white'
            }`}
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-1">
            {services.map((s) => (
              <Link
                key={s.slug}
                to={`/category/${s.slug}`}
                className="px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100 rounded-md cursor-pointer transition-colors"
              >
                {s.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100 rounded-md cursor-pointer transition-colors"
            >
              关于我们
            </Link>
            <div className="border-t border-background-200 mt-2 pt-3">
              <Link
                to="/category/domain-registration"
                className="block w-full text-center bg-primary-500 hover:bg-primary-600 text-background-50 py-2.5 rounded-md text-sm font-medium cursor-pointer"
              >
                立即开始
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}